module.exports = __webpack_public_path__ + "static/media/SecretSantaSocietyChildrensBookIllustration.a1060b35.jpg";